import React, { useState, useEffect, useContext, useRef } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { faList, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import "./Users.css";
import ListWithFilters from "../ListWithFilters/ListWithFilters";
import AddUserModal from "./AddUserModal";
import SocketContext from "../../contexts/SocketContext";
import UserCards from "./UserCards";
import { gsap } from "gsap";

// import AddCustomerModal from "./AddCustomerModal";

const Users = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // States to hold Data and ListData
  const [data, setData] = useState();
  const [listdata, setListData] = useState();
  const [reloaddata, setReloaddata] = useState(false);

  // View State
  const [viewlist, setViewlist] = useState(true);

  // Show Hide
  const [showUserDetails, setShowUserDetails] = useState(false); //customer details
  const [showAddUserModal, setShowAddUserModal] = useState(false); //add customer modal

  // Success Message
  const successMSGRef = useRef();
  const [showsuccess, setShowsuccess] = useState(false);
  const [successMSG, setSuccessMSG] = useState("");

  // Selected User
  const [selectedUser, setSelectedUser] = useState();

  // Card View
  const [userfilter, setUserfilter] = useState("");
  const [carddata, setCarddata] = useState();

  // Join and Leave Users Room
  useEffect(() => {
    socket.emit("joinusersroom");
    return () => {
      socket.emit("leaveusersroom");
    };
  }, []);

  // Load all users and set them in Data
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getCustomers = async () => {
      try {
        const response = await axiosPrivate.post("/api/users/getusers");
        isMounted && setListData(response.data);
        isMounted && setData(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getCustomers();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [reloaddata]);

  // Select User Function to pass to List With Filters
  const selectUser = (item) => {
    setShowUserDetails(true);
    setSelectedUser(item);
    if (location.pathname === "/admin/users" || location.pathname === "/admin") {
      navigate("/admin/users/userdetails", { state: { from: location }, replace: true });
    }
  };

  // Filter Card Data
  useEffect(() => {
    if (listdata && listdata.length > 0) {
      if (userfilter) {
        let temp = listdata.filter(
          (item) =>
            item.name?.toLowerCase().includes(userfilter?.toLowerCase()) ||
            item.lastname?.toLowerCase().includes(userfilter?.toLowerCase()) ||
            item.role?.toLowerCase().includes(userfilter?.toLowerCase())
        );
        setCarddata(temp);
      } else {
        setCarddata(listdata);
      }
    }
  }, [userfilter, listdata]);

  //socket functions
  const receivednewuser = (newitem) => {
    socket && setListData((prev) => [...prev, newitem]);
  };
  const receivedupdateuser = (item) => {
    socket &&
      setListData((prev) => {
        let ind = prev.findIndex((it) => it.userID === item.userID);
        if (ind !== -1) {
          return [...prev.slice(0, ind), item, ...prev.slice(ind + 1, prev.length)];
        } else return [...prev];
      });
  };

  //suscribe to socket events
  useEffect(() => {
    socket.on("enewuser", (newitem) => {
      receivednewuser(newitem);
    });
    // socket.on("edeleteprodspec", (id) => {
    //   receiveddelspec(id);
    // });
    socket.on("eupdateuser", (item) => {
      receivedupdateuser(item);
    });
    return () => {
      socket.off("enewuser");
      // socket.off("edeleteprodspec");
      socket.off("eupdateuser");
    };
  }, [socket]);

  // Show Success Msg
  const onSPMComplete = () => {
    setSuccessMSG(null);
  };
  useEffect(() => {
    const elem = successMSGRef.current;
    if (successMSG) {
      gsap.fromTo(elem, { opacity: 0.5, top: "-20px" }, { opacity: 1, top: 0, duration: 0.1, ease: "power2.in" });
      gsap.fromTo(
        elem,
        { opacity: 1 },
        {
          opacity: 0,
          duration: 3,
          ease: "power2.inOut",
          onComplete: onSPMComplete,
        }
      );
    }
  }, [showsuccess]);

  return (
    <div className='userList'>
      <AddUserModal
        show={showAddUserModal}
        setShow={setShowAddUserModal}
        reloaddata={reloaddata}
        setReloaddata={setReloaddata}
      />
      <div className='ulheader'>
        <div className='ulsubheader'>
          {viewlist && <h1>User List</h1>}
          {!viewlist && <h1>User Cards</h1>}
        </div>
        <div className='success-msg' ref={successMSGRef}>
          {successMSG}
        </div>
        <div className='viewusersas'>
          <p>View as:</p>
          <FontAwesomeIcon
            className='viewusericon'
            icon={faList}
            onClick={(e) => {
              setViewlist(true);
            }}
          />
          <FontAwesomeIcon
            className='viewusericon'
            icon={faAddressCard}
            onClick={(e) => {
              setViewlist(false);
            }}
          />
          <FontAwesomeIcon
            className='viewusericon'
            icon={faPlusSquare}
            onClick={(e) => {
              setShowAddUserModal(true);
            }}
          />
        </div>
      </div>
      {!viewlist && (
        <input
          className='usercardsearch'
          placeholder='search'
          type='text'
          onChange={(e) => setUserfilter(e.target.value)}
        />
      )}
      <div className='userListContent'>
        {viewlist && (
          //USER LIST VIEW
          <ListWithFilters
            data={listdata}
            columns={["userCode", "name", "lastname", "user", "role", "active", "firstLogin"]}
            rowID={"userID"}
            sortable={true}
            sortDirections={["none", "ASC", "ASC", "none", "none", "none", "none"]}
            size={["S", "M", "M", "L", "M", "S", "S"]}
            onRowClick={selectUser}
            placeHolders={true}
            rowIndex={true}
            placeHolderList={["userCode", "name", "lastname", "user", "role", "active", "firstLogin"]}
          />
        )}
        {!viewlist && (
          //CARD LIST VIEW
          <UserCards data={carddata} onCardClick={selectUser} />
        )}
        {selectedUser && (
          <Outlet
            context={[
              showUserDetails,
              selectedUser,
              setSelectedUser,
              setReloaddata,
              reloaddata,
              setShowsuccess,
              setSuccessMSG,
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default Users;
